import React, { Component } from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import "html5-history-api";

export class NoValidLicense extends Component {
  displayName = NoValidLicense.name

  _homeLink = () => {
    this.props.history.push("/");
  }

  render() {
    return (
      <div>
        <div className="ms-font-xxl ms-fontWeight-semibold">No license</div>
        <p>We couldn't find a valid license for MeetingRoomMap. Please make sure that you have a valid license from the Office store.</p>
        <PrimaryButton onClick={ this._homeLink.bind(this._homeLink) }>Re-check license</PrimaryButton>
      </div>
    );
  }
}
